// extracted by mini-css-extract-plugin
export default {"app":"BaseApp_app__iY9LR","smoothScroll":"BaseApp_smoothScroll__Fz08+","section":"BaseApp_section__X9TcN","swiper-slide":"BaseApp_swiper-slide__Quktk"};